<template>
  <div class="container mt--8 pb-5">
    <vue-progress-bar />
    <div class="row justify-content-center">
      <div class="col-lg-5 col-md-6">
        <div class="card bg-secondary shadow border-0">
          <div class="card-header bg-transparent pb-5">
            <div class="text-center mt-5">
              <img src="@/assets/app_logo.png" alt="Logo" width="50%" />
            </div>
          </div>
          <div class="card-body px-lg-5 py-lg-3">
            <form role="form">
              <span class="error" v-if="isEmailEmpty">* Email Required</span>
              <base-input
                class="input-group-alternative mb-3"
                placeholder="Enter Your Email"
                addon-left-icon="ni ni-email-83"
                v-model="email"
                type="email"
                @input="onInputChanged()"
                @keyup="onKeyUp"
              ></base-input>
              <div class="text-center">
                <base-button
                  class="my-5 btn-login"
                  @click="onSubmit(email)"
                  :disabled="isLoading"
                >{{ sendText }}</base-button>
              </div>
              <div class="text-center" v-if="errors">
                <span class="error">{{'* ' + errors.message }}</span>
              </div>
              <div class="text-center mb-4" v-if="showMessage">
                <span
                  style="color: white; font-size: 15px;"
                >Please check your email to receive new verification !</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { FORGET_PASSWORD } from '@/store/actions.type'

export default {
  data() {
    return {
      email: null,
      sendText: 'Send',
      isLoading: false,
      isEmailEmpty: false,
      showMessage: false
    }
  },
  methods: {
    onSubmit(email) {
      if (this.email) {
        this.$store
          .dispatch(FORGET_PASSWORD, this.email)
          .then(() => {
            this.showMessage = true
            this.sendText = 'Resend'
          })
          .catch(() => {
            this.sendText = 'Resend'
          })
      } else {
        this.isEmailEmpty = true
      }
    },
    onInputChanged() {
      this.$store.state.auth.errors = null
      this.isEmailEmpty = false
    },
    onKeyUp(e) {
      if (e.keyCode === 13) {
        this.onSubmit()
      }
    }
  },
  computed: {
    ...mapState({
      errors: state => {
        return state.auth.errors
      }
    })
  }
}
</script>

<style scoped>
.container {
  margin-top: 150px !important;
}
.bg-secondary {
  background-color: #962100 !important;
}
.card-header {
  border-bottom: none !important;
}
.btn-login {
  color: #962100;
  background-color: white;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 2rem !important;
  border-color: transparent !important;
  padding-left: 50px;
  padding-right: 50px;
}
.btn-login:hover {
  color: #962100;
  background-color: white;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 2rem !important;
  border-color: transparent !important;
  padding-left: 50px;
  padding-right: 50px;
}
.btn-login:active:focus {
  color: #962100 !important;
  background-color: rgba(255, 255, 255, 0.5) !important;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
  border-radius: 2rem !important;
  border-color: transparent !important;
  padding-left: 50px;
  padding-right: 50px;
}
.error {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}

</style>
